module.exports = __webpack_public_path__ + "img/8_1.2d6e8c6f.png";